/**
*
*   Video
*       - A Video player on load with an image preload and image fallback for mobile
*
**/
'use client';
import Image from '@/components/image';
import Preloader from '@/components/preloader';
import Player from '@vimeo/player';
import { useRef, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';

//Build the Element
export default function Video({ children, video, settings, thumbnail, breakpoints = {}, ...props }){

	const t = useTranslations();

	//Swiper $el reference
	const ref = useRef();

	//Is the video loading
	const [ loading , setLoading ] = useState(false);

	//Have we loaded the video
	const [ loaded , setLoaded ] = useState(false);

	//Default Breakpoints
	breakpoints = { min:null, max:null , ...breakpoints };

	//Video Class
	const Video = {

		//The Video Thumbnail
		thumbnail: `https://vumbnail.com/${ video }.jpg`,

		//Initialize the Video Player when within breakpoints
		build: () => {

			//Get the iframe
			const $container = ref.current;
			const $video = $container.querySelector('.player');
			const width = window.innerWidth;

			//Skip if empty player div
			if(!$video) return;

			//Skip Initializing when outside breakpoints
			if( ( breakpoints.min && ( window.innerWidth < breakpoints.min ) ) || ( breakpoints.max && ( window.innerWidth > breakpoints.max ) ) )
				return;

			//If we already have a player, skip
			if( $video?.player ) return;

			setLoading(true);

			//Assign the player
			$video.player = new Player($video,{
				badge:      0,
				background: 1,
				controls:   0,
				autoplay:   1,
				loop:       1,
				autopause:  0,
				...settings,
				id: video
			});

			//Toggle play state
			$video.player.on( 'pause' , () => $container.classList.remove('playing') );
			$video.player.on( 'play' , () => {
				$container.classList.add('playing');
				setLoading(false);
			});

		}

	};

	//Setup the Resize Effects
	useEffect(()=>{

		//On Resize
		window.addEventListener('resize', Video.build );

		//Initialize
		Video.build();

		//Remove Event
		return () => window.removeEventListener('resize', Video.build );

	// eslint-disable-next-line react-hooks/exhaustive-deps
	},[ ref.current ]);


	//Return
	return (
		<div className="video" ref={ ref }>
			<div className="player">
				<Preloader status={ loading } />
				{ thumbnail && (
					<Image className="poster" src={ Video.thumbnail } alt="" placeholder="blur" blurDataURL={ Video.thumbnail } fill />
				)}
				{ children }
			</div>
		</div>
	);


}